import React, { useEffect, useState } from 'react';
import { string, func } from 'prop-types';

import keys from '../../utils/keys';

function Search({
  buttonLabel,
  id,
  label,
  onSearch,
  placeholder,
  value: defaultValue
}) {
  const [value, setValue] = useState(defaultValue);

  function handleKeyDown(e) {
    if (e.keyCode === keys.enter) {
      onSearch(value);
    }
  }

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <div className="field">
      {label && (
        <label className="faculty-staff-listing__search-label" htmlFor={id}>
          {label}
        </label>
      )}
      <div className="field__input-wrapper">
        <input
          autoComplete="off"
          id={id}
          type="text"
          className="field__input"
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          title={placeholder}
          value={value}
          {...(placeholder && { placeholder })}
        />
        <button
          className="faculty-staff-listing__search-button"
          onClick={() => onSearch(value)}
          aria-label={buttonLabel}
        >
          <svg aria-hidden="true">
            <use xlinkHref="#search-outline" />
          </svg>
        </button>
      </div>
    </div>
  );
}

Search.propTypes = {
  buttonLabel: string.isRequired,
  label: string,
  onSearch: func.isRequired,
  placeholder: string
};

export default Search;
